import React, { useState, useEffect } from "react";
import RentalItem from "./RentalItem";
import { DATABASE_MAIN } from '../contexts/api';
import { useTranslation } from "react-i18next";
import "../localization/i18n";

const RentalList = (props) => {
  const { t } = useTranslation();
  const [repository, setRepository] = useState([]);
  const [filteredRepository, setFilteredRepository] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [limit, setLimit] = useState(12);
  const [itemsCount, setItemsCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [actionChanged, setActionChanged] = useState([]);

  async function fetchRepository() {
    setIsLoading(true);
    await fetch(`${DATABASE_MAIN}/rentalItems.php`)
      .then((response) => {
        response.json().then((data) => {
          let order = 1;
          const trasformedRepository = data.map((rep) => {
            return {
              id: rep.id,
              order: order++,
              name: rep.name,
              description: rep.description,
              fromDate: rep.fromDate,
              toDate: rep.toDate,
              rentier: rep.rentier,
              lastRentier: rep.lastRentier,
              state: rep.state,
              place: rep.place,
            };
          });
          setIsLoading(false);
          //setPages(trasformedRepository.length/limit);
          setItemsCount(trasformedRepository.length);
          return setRepository(trasformedRepository);
        });
      })
      .catch((error) => {
        console.log(error); 
      });
  }

  useEffect(() => {
    //console.log(actionChanged);

    /*setRepository(
      repository.map((item) => {
        if (item.id === actionChanged.id) {
          return { ...item,
            state: actionChanged.state,
            rentier: actionChanged.rentier,
            lastRentier: actionChanged.lastRentier,
           };
      } else return item;
        
    }));*/

    fetchRepository();
  }, [actionChanged]);

  useEffect(() => {
    window.scrollTo({ behavior: "smooth", top: "0px" });
  }, [props.actualPage]);

  useEffect(() => {        
    if (searchTerm.trim().length > 0) {
      setFilteredRepository(
        repository
          .filter((fitem) => czechCharacterRegex(fitem.name).toLowerCase().includes(czechCharacterRegex(searchTerm).toLowerCase()))
          .map((item) => (
            <RentalItem
              key={"re"+item.id}
              onAction={setActionChanged}
              sourceItem={item}
            />
          ))
      );
    } else {
      setFilteredRepository(
        repository
        //.filter(item => item.order > page*limit &&  item.order <=page*limit + limit)
        .filter(item => item.order <=limit)
        .map((item) => (
          <RentalItem
            key={"re"+item.id}
            onAction={setActionChanged}
            sourceItem={item}
          />
        ))
      );
    }
  }, [searchTerm, repository, limit]);

  const filterChangeHandler = (event) => {
    setSearchTerm(event.target.value);
    setLimit(12);
  };

  const onNextClickedHandler = () => {
    if (limit+12 < itemsCount)
        setLimit(limit+12);
      else
        setLimit(itemsCount);
  };

  const czechCharacterRegex = keyword => keyword
  .replace(/[žŽzZ]/g, '[žŽzZ]')
  .replace(/[šŠsS]/g, '[šŠsS]')
  .replace(/[čČcC]/g, '[čČcC]')
  .replace(/[řŘrR]/g, '[řŘrR]')
  .replace(/[ňŇnN]/g, '[ňŇnN]')
  .replace(/[ěĚeE]/g, '[ěĚeE]')
  .replace(/[éÉeE]/g, '[éÉeE]')
  .replace(/[ýÝyY]/g, '[ýÝyY]')
  .replace(/[áÁaA]/g, '[áÁaA]')
  .replace(/[íÍiI]/g, '[íÍiI]')
  .replace(/[úÚuU]/g, '[úÚuU]')
  .replace(/[ůu]/g, '[ůu]');

  return (
    <div id="rentalList" className="pt-3">
      {isLoading && <div className="spinner-border text-info"></div>}
      
      <div className="text-center pt-2">
        <div className="form-floating mb-3">
          <input
            type="search"
            className="form-control"
            id="search"
            placeholder={t("search")}
            name="search"
            onChange={filterChangeHandler}
            value={searchTerm}
          />
          <label htmlFor="search">{t("search")}</label>
        </div>
      </div>

      <div className="container-fluid-md rentals">
        <div className="row">{filteredRepository}</div>
      </div>

      <div className="text-center pb-2">
        <div><button className="btn btn-primary" onClick = {onNextClickedHandler}>{t("next")}</button></div>
      </div>
      
    </div>
  );
};

export default RentalList;